import { jsx } from 'react/jsx-runtime';

const SvgStatusPaused = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M10 5H7v14h3V5ZM17 5h-3v14h3V5Z" }) }));

export { SvgStatusPaused as default };
//# sourceMappingURL=StatusPaused.es.js.map
